<template>
  <div class="d-inline-block print-receipt-button">
    <v-tooltip
      :bottom="tooltipPosition === 'bottom'"
      :close-delay="tooltipCloseDelay"
      :color="color"
      :disabled="disabled || disableTooltip"
      :left="tooltipPosition === 'left'"
      :open-delay="tooltipOpenDelay"
      :right="tooltipPosition === 'right'"
      :top="tooltipPosition === 'top'"
    >
      <template #activator="{on}">
        <v-btn
          :absolute="absolute"
          :block="block"
          :class="[btnClass, icon ? color : '', {'grey lighten-2': disabled && icon}]"
          :color="icon ? '' : color"
          :dark="dark"
          :depressed="depressed"
          :disabled="disabled"
          :fab="fab"
          :fixed="fixed"
          :icon="icon"
          :large="large"
          :outlined="outline"
          :small="small"
          :style="btnStyle ? btnStyle : small ? icon ? `width: ${smallSize}px; height: ${smallSize}px;` : `height: ${smallSize}px;` : ''"
          :text="flat"
          @click="onButtonClick"
          v-on="on"
        >
          <v-icon
            v-if="!hideIcon"
            :left="!!label && !hideLabel && !icon"
            :small="small && smallIcon"
          >
            {{ iconName }}
          </v-icon>
          <span v-if="label && !hideLabel && !icon">{{ label }}</span>
        </v-btn>
      </template>

      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import Auth from '@/mixins/auth'
import AppData from '@/mixins/appdata'

export default {
  name      : 'PrintReceiptButton',
  components: {},
  directives: {},
  mixins    : [Auth, AppData],
  props     : {
    tooltip: {
      type   : String,
      default: function () {
        return this.$t('Common.Button.PrintDocument')
      }
    },
    label: {
      type   : String,
      default: function () {
        return this.$t('Common.Button.PrintDocument').toLocaleUpperCase(this.$i18n.locale)
      }
    },
    hideLabel: {
      type   : Boolean,
      default: false
    },
    btnClass: {
      type   : String,
      default: 'white--text ma-0'
    },
    btnStyle: {
      type   : String,
      default: ''
    },
    color: {
      type   : String,
      default: 'blue-grey'
    },
    icon: {
      type   : Boolean,
      default: false
    },
    iconName: {
      type   : String,
      default: 'mdi-printer'
    },
    hideIcon: {
      type   : Boolean,
      default: false
    },
    small: {
      type   : Boolean,
      default: false
    },
    smallIcon: {
      type   : Boolean,
      default: false
    },
    smallSize: {
      type   : Number,
      default: 32
    },
    large: {
      type   : Boolean,
      default: false
    },
    outline: {
      type   : Boolean,
      default: false
    },
    flat: {
      type   : Boolean,
      default: false
    },
    depressed: {
      type   : Boolean,
      default: false
    },
    absolute: {
      type   : Boolean,
      default: false
    },
    disabled: {
      type   : Boolean,
      default: false
    },
    block: {
      type   : Boolean,
      default: false
    },
    fixed: {
      type   : Boolean,
      default: false
    },
    fab: {
      type   : Boolean,
      default: false
    },
    dark: {
      type   : Boolean,
      default: false
    },
    tooltipPosition: {
      type   : String,
      default: 'top'
    },
    tooltipOpenDelay: {
      type   : Number,
      default: 150
    },
    tooltipCloseDelay: {
      type   : Number,
      default: 150
    },
    disableTooltip: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {},
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onButtonClick() {
      this.$emit('fiscal-document:print')
    }
  }
}
</script>

<style scoped>

</style>
